module.exports = __webpack_public_path__ + "static/img/A115.3618b6ab.jpg";